const chunkMapping = {
	"44": [
		44
	],
	"242": [
		2242
	],
	"467": [
		9467
	],
	"554": [
		2554
	],
	"581": [
		5581
	],
	"797": [
		4797
	],
	"831": [
		4831
	],
	"847": [
		6847
	]
};
const idToExternalAndNameMapping = {
	"44": [
		"default",
		"./management",
		6518
	],
	"2242": [
		"default",
		"./public-path",
		6518
	],
	"2554": [
		"default",
		"./admin",
		6518
	],
	"4797": [
		"default",
		"./public-path",
		3430
	],
	"4831": [
		"default",
		"./store",
		3430
	],
	"5581": [
		"default",
		"./AuthProvider",
		3430
	],
	"6847": [
		"default",
		"./RequireAuth",
		3430
	],
	"9467": [
		"default",
		"./Login",
		3430
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}